import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
Vue.use(Vuex)
Vue.use(ElementUI);

// 导入axios和store
import axios from 'axios'
import store from '../store'
import {
    setCookie
} from '../assets/cookie'
import globalDatas from '../globalDatas'

// 创建路由实例
const router = new Router({
    routes: [{
            path: '*',
            redirect: '/shopping/home',
        },
        {
            path: '/shopping',
            name: 'shopping',
            component: () => import('../components/index/index.vue'),
            children: [{
                    path: 'login',
                    name: 'login',
                    component: () => import('../components/public/login.vue'),
                },
                {
                    path: 'forget',
                    name: 'forget',
                    component: () => import('../components/public/forget.vue'),
                },
                {
                    path: 'regist',
                    name: 'regist',
                    component: () => import('../components/public/regist.vue'),
                },
                {
                    path: 'change',
                    name: 'change',
                    component: () => import('../components/public/change.vue'),
                },
                {
                    path: 'home',
                    name: 'home',
                    component: () => import('../components/home/home.vue'),
                },
                {
                    path: 'company_brand',
                    name: 'company_brand',
                    component: () => import('../components/brand/brand.vue'),
                },
                {
                    path: 'business',
                    name: 'business',
                    component: () => import('../components/business/business.vue'),
                },
                {
                    path: 'loan',
                    name: 'loan',
                    component: () => import('../components/loan/loan.vue'),
                },
                {
                    path: 'purchase',
                    name: 'purchase',
                    component: () => import('../components/purchase/purchase.vue'),
                },
                {
                    path: 'purchase_detail',
                    name: 'purchase_detail',
                    component: () => import('../components/purchase/detail.vue'),
                },
                {
                    path: 'bondi',
                    name: 'bondi',
                    component: () => import('../components/shopping/bondi.vue'),
                },
                {
                    path: 'mall',
                    name: 'mall',
                    component: () => import('../components/shopping/shopping.vue'),
                },
                {
                    path: 'good_detail',
                    name: 'good_detail',
                    component: () => import('../components/shopping/gooddetail.vue'),
                },
                {
                    path: 'goodsearch',
                    name: 'goodsearch',
                    component: () => import('../components/shopping/goodsearch.vue'),
                },
                {
                    path: 'cart',
                    name: 'cart',
                    component: () => import('../components/shopping/cart.vue'),
                },
                {
                    path: 'confirm_order',
                    name: 'confirm_order',
                    component: () => import('../components/shopping/confirmorder.vue'),
                },
                {
                    path: 'success_order',
                    name: 'success_order',
                    component: () => import('../components/shopping/successorder.vue'),
                },
                {
                    path: 'orderlist',
                    name: 'orderlist',
                    component: () => import('../components/shopping/orderlist.vue'),
                },

                {
                    path: 'introduct',
                    name: 'introduct',
                    component: () => import('../components/article/article.vue'),
                },
                {
                    path: 'personal',
                    name: 'personal',
                    component: () => import('../components/personal/person.vue'),
                },
                {
                    path: 'supplierstore',
                    name: 'supplierstore',
                    component: () => import('../components/shopping/supplierstore.vue'),
                },
            ]
        },
        {
            path: '/app_download',
            name: 'app_download',
            component: () => import('../components/appload/appload.vue'),
        },
        {
            path: '/business_regist',
            name: 'business_regist',
            component: () => import('../components/business/businessregist.vue'),
        },
        {
            path: '/document_detail',
            name: 'document_detail',
            component: () => import('../components/purchase/document.vue'),
        },
        {
            path: '/order_detail',
            name: 'orderdetail',
            component: () => import('../components/shopping/orderdetail.vue'),
        },
    ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 从地址栏获取token
    const urlToken = to.query.token

    if (urlToken) {
        // 将token存储到sessionStorage
        sessionStorage.setItem('token', urlToken)
        sessionStorage.setItem('hasLogin', true)
        setCookie('token', urlToken, 43200) // 60*60*12 12个小时
        
        // 更新store中的token
        store.commit('setToken', urlToken)

        // 从sessionStorage获取token
        const token = sessionStorage.getItem('token')
        const cid = sessionStorage.getItem('cid') || ''

        if (token) {
            // 设置axios默认token
            axios.defaults.headers.common['token'] = token

            // 获取用户信息
            const getUserInfo = () => {
                let obj2 = {
                    cid: cid,
                    token: token
                }

                let url = globalDatas.geturl.call({}, obj2, process.env.VUE_APP_API_HOST + '/member/detail')
                axios.get(url).then(function(res) {
                    if (res.data.code == 1) {
                        // 将用户信息存储到Vuex
                        store.commit('login', {
                            ...res.data.data,
                            token: token
                        })

                        // 如果当前是登录页，则跳转到首页
                        if (to.path === '/shopping/login') {
                            router.push('/shopping/home')
                        }
                    }
                }).catch(function(error) {
                    console.log(error)
                })
            }

            // 调用获取用户信息的函数
            getUserInfo()
        }

        // 如果是登录页，不直接调用next，等待API返回后重定向
        if (to.path !== '/shopping/login') {
            // 重定向到当前路径，移除token参数
            next({
                path: to.path,
                query: {
                    ...to.query,
                    token: undefined
                }
            })
        } else {
            // 对于登录页，先移除token参数，但不立即跳转
            next({
                path: to.path,
                query: {
                    ...to.query,
                    token: undefined
                }
            })
        }
    } else {
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js